import { useGetSupplierNationalIDImages } from '@/modules/workforce/Crew/apiHooks';
import { AddEditForm } from '@/modules/workforce/Crew/components/AddEditForm';
import { IAddCrewForm } from '@/modules/workforce/Crew/types';

interface AddEditCrewProps {
  crewId?: number;
  initialValues?: IAddCrewForm;
  onSuccess?: () => void;
}

export const AddEditCrew: React.FC<AddEditCrewProps> = ({
  crewId,
  initialValues,
  onSuccess,
}) => {
  const { data: nationalIdImages } = useGetSupplierNationalIDImages({
    supplierId: crewId,
  });

  const formInitialValues = {
    ...initialValues,
    nationalIdBack: nationalIdImages?.backUrl
      ? [{ dataURL: nationalIdImages?.backUrl }]
      : undefined,
    nationalIdFront: nationalIdImages?.frontUrl
      ? [{ dataURL: nationalIdImages?.frontUrl }]
      : undefined,
  } as IAddCrewForm;

  return (
    <AddEditForm
      crewType='crew'
      initialValues={crewId ? formInitialValues : undefined}
      memberId={crewId}
      onSuccess={onSuccess}
    />
  );
};
